var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-footer',{attrs:{"color":"white"}},[_c('v-col',{staticClass:"caption text-center",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(_vm.year)+" Impactiv - Tous droits réservés ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }